import React, { useState } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { PaymentElement } from '@stripe/react-stripe-js';
import FormLabel from '@mui/material/FormLabel';
import { useDeviceDetect } from 'hooks';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function PaymentForm({ label, helperText, onChange, classes }) {
  const styles = useStyles();
  const { isMobile } = useDeviceDetect();
  const [isElementsReady, setIsElementsReady] = useState(false);

  const paymentClasses = cn(styles.paymentWrapper, classes);

  return (
    <div className={paymentClasses} style={{ width: isMobile && '100%' }}>
      <FormLabel component="legend">{label}</FormLabel>
      {!isElementsReady && (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      )}
      <PaymentElement onReady={() => setIsElementsReady(true)} className={styles.paymentElement} onChange={onChange} />
      {helperText?.length && (
        <Typography className={styles.paymentMessage} color="error" variant="body1" component="span">
          {helperText}
        </Typography>
      )}
    </div>
  );
}

PaymentForm.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  helperText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  classes: PropTypes.string,
};

PaymentForm.defaultProps = {
  helperText: '',
  classes: '',
};

export default PaymentForm;
